import { Location } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { IonButton, ModalController } from '@ionic/angular/standalone';

@Component({
  selector: 'mtjr-cancel-button',
  imports: [IonButton],
  template: `
    <ion-button fill="outline" type="button" class="mx-2" (click)="cancel()">{{ label() }}</ion-button>
  `,
})
export class VxCancelButtonComponent {
  label = input('Cancel');
  class = input('');
  modalCtrl = inject(ModalController);

  cancel() {
    this.modalCtrl.dismiss();
  }
}

@Component({
  selector: 'mtjr-back-button',
  imports: [IonButton],
  template: `
    <ion-button fill="outline" type="button" class="mx-2" (click)="cancel()">{{ label() }}</ion-button>
  `,
})
export class VxBackButtonComponent {
  label = input('Cancel');
  class = input('');
  location = inject(Location);

  cancel() {
    this.location.back();
  }
}
